<p-confirmDialog key="useraddstaff" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Staff Info-->
<div class="MainGrid2Col">
	<label>School:</label>
	<label class="InfoText">{{ School.SchoolFullName }}</label>
	<!-- <select disabled class="form-control" name="School" [(ngModel)]="School">
        <option value="" style="display:none;"></option>
        <option *ngFor="let o of lstSchool" [ngValue]="o">{{o.SchoolFullName}}</option>
    </select> -->

	<label>First Name:</label>
	<input class="form-control" type="text" [(ngModel)]="FirstName" placeholder="First Name" />

	<label>Last Name:</label>
	<input class="form-control" type="text" [(ngModel)]="LastName" placeholder="Last Name" />

	<label>Staff ID:</label>
	<input class="form-control" type="text" [(ngModel)]="StaffID" placeholder="Unique Staff ID" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
